import { render, staticRenderFns } from "./PageBlog.vue?vue&type=template&id=ee73d02c&scoped=true&"
import script from "./PageBlog.vue?vue&type=script&lang=js&"
export * from "./PageBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee73d02c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ohid/instaprivat/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee73d02c')) {
      api.createRecord('ee73d02c', component.options)
    } else {
      api.reload('ee73d02c', component.options)
    }
    module.hot.accept("./PageBlog.vue?vue&type=template&id=ee73d02c&scoped=true&", function () {
      api.rerender('ee73d02c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/blog/PageBlog.vue"
export default component.exports